<template>
  <div class="modal fade" id="bill-client-modal" data-backdrop="static" data-keyboard="false" tabindex="-1"
       role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body">
          <div class="d-flex justify-content-between align-items-center">
            <span class="badge badge-soft-success text-uppercase badge font-12px bg-primary-blink text-white">
              Create Bill
            </span>
            <button type="button" class="btn btn-light position-relative p-0 avatar-xs rounded-circle pull-right close-modal"
                    data-bs-dismiss="modal" aria-label="Close">
              <span class="avatar-title bg-transparent text-reset font-18px">
                <i class="bx bx-x"></i>
              </span>
            </button>
          </div>

          <div class="payment-panel-parent">
            <div class="payment-active-panel d-flex flex-column justify-content-around align-items-center sent-success payment-panel">
              <div class="success-image mb-4 pb-4 pt-4">
                <img src="assets/images/bills.svg" height="100" alt="">
              </div>

              <h4 class="text-black fw-bold">Create Bill</h4>

              <div class="border-1 invoice-form p-4">
                <div class="form-group mb-4">
                  <div class="row">
                    <div class="col-6">
                      <label class="text-uppercase">Unit Number:</label>
                    </div>
                    <div class="col-6">
                      <p class="text-black fw-bold">{{ unit?.unitNo || 'N/A' }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-uppercase">Owner:</label>
                    </div>
                    <div class="col-6">
                      <p class="text-black fw-bold">{{ unit?.occupants || 'N/A' }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-uppercase">Monthly Rent:</label>
                    </div>
                    <div class="col-6">
                      <p class="text-black fw-bold">{{ unit?.monthlyRent || 0 }}</p>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <label class="text-uppercase">Arrears:</label>
                    </div>
                    <div class="col-6">
                      <p class="text-black fw-bold">KES {{ unit?.arrears || 0 }}</p>
                    </div>
                  </div>
                </div>

                <p class="text-muted mb-4">
                  Please input the desired payment amount based on the outstanding arrears or what the client wishes to pay
                </p>

                <div class="col-12">
                  <div class="mb-3">
                    <label class="form-label">Income Type</label>
                    <select @change="selectedIncomeType($event)" class="form-control show-tick">
                      <option v-for="(item, index) in incomeTypes" :value="JSON.stringify(item)" :key="index">
                        {{ item.incomeTypeDescription }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-12">
                  <div class="mb-3">
                    <label class="form-label">Fee type</label>
                    <select @change="selectedFeeAndCharge($event)" class="form-control bg-white">
                      <option v-for="(item, index) in feesAndCharges" :value="JSON.stringify(item)" :key="index">
                        {{ item.feeDescription }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <label class="form-label">Amount to Invoice</label>
                      <input v-model="amount" type="text" class="form-control" placeholder="Amount">
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex w-100 pb-2" style="margin-top: 20px">
                <button @click="generateBill()" type="button" class="btn btn-primary btn-block me-3 flex-grow-1" :disabled="generating">
                  <span v-if="generating">
                    <span class="spinner-border spinner-border-sm me-2"></span>
                    Generating...
                  </span>
                  <span v-else>
                    <i class="mdi-cash-check mdi font-size-16 align-middle me-2"></i>
                    Create Invoice
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { execute, biller } from "@/api";

export default {
  name: "BillClientModal",
  props: {
    unit: {
      type: Object,
      default: () => ({})
    },
    incomeTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      amount: 0,
      feesAndCharges: [],
      feeID: null,
      unitFeeAmount: null,
      feesAndChargeItems: [],
      billItem: [],
      message: null,
      generating: false
    };
  },
  watch: {
    unit: {
      immediate: true,
      handler(newUnit) {
        if (newUnit) {
          this.amount = newUnit.monthlyRent || 0;
        }
      }
    },
    incomeTypes: {
      immediate: true,
      handler(newTypes) {
        if (newTypes && newTypes.length > 0) {
          this.getFeesAndChargesBilling(newTypes[0].incomeTypeId);
        }
      }
    }
  },
  methods: {
    show() {
      const modal = new window.bootstrap.Modal(document.getElementById('bill-client-modal'));
      modal.show();

      if (this.incomeTypes && this.incomeTypes.length > 0) {
        this.getFeesAndChargesBilling(this.incomeTypes[0].incomeTypeId);
      }
    },

    hide() {
      const modal = window.bootstrap.Modal.getInstance(document.getElementById('bill-client-modal'));
      if (modal) {
        modal.hide();
      }
    },

    selectedIncomeType(event) {
      const value = event.target.value;
      const result = JSON.parse(value);
      this.getFeesAndChargesBilling(result.incomeTypeId);
    },

    getFeesAndChargesBilling(incomeTypeId) {
      this.feesAndCharges = [];
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges;
              this.selectedFeeAndChargeFirstOne();
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    selectedFeeAndCharge(event) {
      const data = JSON.parse(event.target.value);
      this.feeID = data.feeId;
      this.unitFeeAmount = data.unitFeeAmount;
      this.feesAndChargeItems = [];
      this.feesAndChargeItems.push(data);
    },

    selectedFeeAndChargeFirstOne() {
      if (this.feesAndCharges.length > 0) {
        const data = this.feesAndCharges[0];
        this.feeID = data.feeId;
        this.unitFeeAmount = data.unitFeeAmount;
        this.feesAndChargeItems = [];
        this.feesAndChargeItems.push(data);
      }
    },

    generateFeeAndChargesItem() {
      const billingDateTime = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });

      let newItem = {
        feeId: this.feeID,
        unitFeeAmount: this.amount,
        customer: `${this.unit.unitNo} | ${this.unit.idNo} | ${this.unit.id} | ${this.unit.occupants} | Arrears as at ${billingDateTime}: KES ${this.unit.arrears}`
      };

      this.feesAndChargeItems = [];
      this.feesAndChargeItems.push(newItem);
      this.addToBill();
    },


    addToBill() {
      this.billItem = [];
      for (const item of this.feesAndChargeItems) {
        this.billItem.push({
          typeDescription: item.typeDescription,
          feeDescription: item.feeDescription,
          unitFeeAmount: item.unitFeeAmount,
          accountNo: item.accountNo,
          costCenterNo: item.costCenterNo,
          incomeTypeId: item.incomeTypeId,
          revenueStreamItem: this.unit.unitNo,
          feeId: item.feeId,
          amount: item.unitFeeAmount,
          customer: item.customer,
          zone: this.unit.zone,
          subCountyID: this.unit.subCountyID,
          subCountyName: this.unit.subCountyName,
          wardID: this.unit.wardID,
          wardName: this.unit.wardName,
          idNo: sessionStorage.getItem("sessionIdNo"),
          phoneNumber: sessionStorage.getItem("sessionPhoneNumber"),
          names: sessionStorage.getItem("sessionNames"),
          customerPhoneNumber: this.unit.phoneNumber,
          description: this.unit.unitNo
        });
      }
    },

    generateBill() {
      this.generating = true;
      this.generateFeeAndChargesItem();

      const data = new FormData();
      data.append("function", "generateBill3");
      data.append("billItem", JSON.stringify(this.billItem));

      execute(data, biller)
          .then((res) => {
            this.generating = false;
            if (res.data.success) {
              // FIXED: Emit the complete bill object instead of just billDetails and billInfo
              this.$emit('bill-generated', {
                bill: res.data.data.bill,  // Complete bill object with billDetails, billInfo, bank, county, etc.
                billGenerated: res.data.data.billGenerated,
                unit: this.unit
              });

              // Close this modal
              this.hide();
            } else {
              alert(res.data.message || "Failed to generate bill");
            }
          })
          .catch((e) => {
            this.generating = false;
            alert("Error: " + e.message);
          });
    }
  }
};
</script>